import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { toast } from "react-toastify";
import tables from "../../../../Data/Tables/Inventory/Requested/tables";
import headers from "../../../../Data/Tables/Inventory/Requested/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_inventories } from "../../../../Controllers/Inventory/Batch";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import { get_all_requested } from "../../../../Controllers/Inventory/Request";
import moment from "moment";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const InventoryRequestedTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        product: tabledata?.product,
        date: tabledata?.date,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const products = await get_all_requested(data);
      if (products?.status) {
        let data = [];

        products?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/inventory/requested/view/${value?._id}`,
            Number: `#REQUEST-${value?.number}`,
            Date: <DateTimeBadge date={value?.date} />,
            Branch: value?.branch?.name,
            Status: (
              <Status
                name={value?.status ? "Not-accepted" : "Accepted"}
                status={value?.status ? 0 : 1}
              />
            ),
            Action: (
              <ActionButton
                edit={`/app/inventory/request/edit/${value?._id}`}
                id={value?._id}
                api="delete-requested"
                actiondata={actiondata}
                headers={header}

              />
            ),
          });
        });

        setPagination({
          currentPage: products?.data?.currentPage,
          totalCount: products?.data?.totalCount,
          totalPages: products?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InventoryRequestedTable;
